const { createStore, action } = require("easy-peasy");

const store = createStore({
  authUser: null,
  setAuthUser: action((state, payload) => {
    state.authUser = payload;
  }),
  readingImage: null,
  setReadingImage: action((state, payload) => {
    state.readingImage = payload;
  }),
  transfers: null,
  setTransfers: action((state, payload) => {
    state.transfers = payload;
  }),
  lateReadings: null,
  setLateReadings: action((state, payload) => {
    state.lateReadings = payload;
  }),
});

export default store;
